const HEADER_CELL = /^(артикул|article|sku|offer_id)$/i;

/** Split pasted text into unique trimmed article codes. */
export function parseArticleList(raw: unknown): string[] {
  if (raw == null) return [];
  const text = Array.isArray(raw)
    ? raw.map((v) => String(v ?? '')).join('\n')
    : String(raw);
  const parts = text
    .replace(/^\uFEFF/, '')
    .split(/[\s,;]+/)
    .map((p) => p.trim())
    .filter(Boolean);
  const out: string[] = [];
  const seen = new Set<string>();
  for (const p of parts) {
    if (HEADER_CELL.test(p)) continue;
    const key = p.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(p);
  }
  return out;
}
